export class AnchorRenderedEvent extends Event {

  anchor: string

  constructor (anchor: string) {
    super('anchorRendered')
    this.anchor = anchor
  }
}
